<template>
  <CustomModal :closableOnClickOutside="false"
               @close="$emit('close')">
    <template v-slot:body>
      <div class="pt-8 flex justify-center flex-wrap" style="width: 400px;">
        <p class="text-text text-md text-center leading-normal mb-8">
          {{ $t('modalText') }}
        </p>
        <BaseButton theme="red" @click="redirect">{{ $t('btnText') }}</BaseButton>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "RedirectModal",
  components: {BaseButton, CustomModal},
  props: {
    redirectLink: {
      type: String,
      required: true
    }
  },
  methods: {
    redirect() {
      // location.href = this.redirectLink;
      window.open(this.redirectLink, '_blank').focus();
      this.$emit('close');
    }
  },
  i18n: {
    messages: {
      en: {
        modalText: 'This service can be connected only on the official website. Please log in via the link.',
        btnText: 'Follow the link',
      },
      ru: {
        modalText: 'Данный сервис можно подключить только через официальный сайт. Пожалуйста пройдите авторизацию по ссылке',
        btnText: 'Перейти',
      }
    }
  }
}
</script>